import React from "react";

import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import { MRC2AttachmentsSection } from "../index";

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete,
}) {
  return (
    <FormSection
      disableAll={disableAll}
      sectionName='MRC2_ATTACHMENTS'
      formikRef={formikRef}
      questionnaire={globalQuestionnaire}
      setQuestionnaire={setGlobalQuestionnaire}
      values={formikProps.values}
      error={formikProps.errors}
      setFieldValue={formikProps.setFieldValue}
      setFieldError={formikProps.setFieldError}
      idOperation={idOperation}
      idOperationParent={idOperationParent}
      onQuestionChange={(question, value, setFieldValue, questionnaireUpdated) =>
        MRC2AttachmentsSection.events.handleQuestionChange({
          question,
          value,
          questionnaireUpdated,
          setQuestionnaire: setGlobalQuestionnaire,
          setFieldValue,
          questionnaireAnswersToDelete,
          setQuestionnaireAnswersToDelete,
          documentsToDelete,
          setDocumentsToDelete
        })
      }
    />
  )
}

const components = {
  RenderSection
}

export { components }